import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  max-width: 150px;
  border-bottom: 1px solid rgb(235,235,235);
  width: calc(100% - 40px);
  margin-left: calc((100% - 700px) / 2);
  margin-right: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 0 0 0.5rem;
  float: left;
  @media (max-width: 740px) {
    margin: 0.5rem 20px 0;
  }
  a {
    text-decoration: none;
    color: rgb(33,33,33);
    display: block;
    &:after {
      content: '';
      display: table;
      clear: both;
    }
  }
  h6 {
    font-size: 0.75rem;
    line-height: 0.875rem;
    margin-bottom: 0.25rem;
  }
  p {
    font-size: 0.75rem;
    line-height: 0.875rem;
  }
  &:after {
    content: '';
    display: table;
    clear: both;
  }
`;

const Image = styled.img`
  width: 100%;
`;

const Interstitial = ({
  content,
  url,
  image,
  imageAlt,
}) => (
  <Wrapper>
    <a href={url}>
      <Image src={image} alt={imageAlt} />
      <h6 className="benton-n6">Related coverage</h6>
      <p className="benton-n4">{content}</p>
    </a>
  </Wrapper>
);

export default Interstitial;

Interstitial.propTypes = {
  content: PropTypes.arrayOf(String).isRequired,
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
};
